export default __webpack_public_path__ + "static/media/grafema_capitolio_15.4758dcea.jpg";